import React, { memo, useState } from 'react';
import { UpdateGmbLocationParams } from '../../../../requests/partner/gmb-locations';
import { Profile } from '../../../../models/gmb-location';

import BaseRaw from './BaseRaw';
import ProfileModal from '../form-modal/ProfileModal';

type Props = {
  label: string;
  profile: Profile | null;
  handleUpdate?: (params: UpdateGmbLocationParams) => Promise<void>;
  editable?: boolean;
  keywords: string[];
  isListedStore: boolean;
};

const PrimaryPhoneRaw: React.FC<Props> = (props) => {
  const editable = props.editable === undefined || props.editable ? true : false;
  const [isShow, setIsShow] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleModal = () => {
    setIsShow(!isShow);
  };
  const handleSubmit = async (params: UpdateGmbLocationParams): Promise<void> => {
    setIsLoading(true);
    try {
      if (props.handleUpdate !== undefined) await props.handleUpdate(params);
      setIsShow(!isShow);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <BaseRaw
        isLoading={isLoading}
        label={props.label}
        value={props.profile?.description || '未設定'}
        handleModal={editable ? handleModal : undefined}
        isHideBtn={props.isListedStore}
      />
      {editable ? (
        <ProfileModal
          isShow={isShow}
          label={props.label}
          profile={props.profile}
          handleModal={handleModal}
          handleUpdate={handleSubmit}
          keywords={props.keywords}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(PrimaryPhoneRaw);
